var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 44,
    viewBox: "0 0 29 44",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4826 0C27.0371 0 28.2974 1.23122 28.2974 2.75V41.25C28.2974 42.7688 27.0371 44 25.4826 44H2.96406C1.40948 44 0.149246 42.7688 0.149246 41.25V2.75C0.149246 1.23122 1.40948 0 2.96406 0H25.4826ZM3.90233 6.41667H24.5443V37.5833H3.90233V6.41667Z",
    fill: "#428EE0"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCAyOSA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuNDgyNiAwQzI3LjAzNzEgMCAyOC4yOTc0IDEuMjMxMjIgMjguMjk3NCAyLjc1VjQxLjI1QzI4LjI5NzQgNDIuNzY4OCAyNy4wMzcxIDQ0IDI1LjQ4MjYgNDRIMi45NjQwNkMxLjQwOTQ4IDQ0IDAuMTQ5MjQ2IDQyLjc2ODggMC4xNDkyNDYgNDEuMjVWMi43NUMwLjE0OTI0NiAxLjIzMTIyIDEuNDA5NDggMCAyLjk2NDA2IDBIMjUuNDgyNlpNMy45MDIzMyA2LjQxNjY3SDI0LjU0NDNWMzcuNTgzM0gzLjkwMjMzVjYuNDE2NjdaIiBmaWxsPSIjNDI4RUUwIi8+DQo8L3N2Zz4NCg==";
export { SvgComponent as ReactComponent };